import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { NitroButton } from 'nitro-components';

import {
  CostcenterFilter,
  CountryFilter,
  SingleSelect
} from '../../../../components/filter';
import FilterSection from '../../../../components/filter/FilterSection';

const Container = styled.div`
  width: 400px;
  margin: 40px auto;
  padding-bottom: 200px;
`;

class DataSource extends Component {
  constructor(props) {
    super(props);

    this.state = {
      country: this.props.country,
      costcenter: this.props.costcenter
    };
  }

  componentDidMount() {
    let disabled = this.props.isEditMode ? false : true;
    if(this.props.businessReport && this.props.businessReport.value)
      disabled = false;

    this.props.setNavigation({
      left: null,
      middle: null,
      right: (
        <NitroButton
          disabled={disabled}
          action={this.props.navigation.goNext}
          label="NEXT"
          variant="primary"
          size="extraSmall"
          rightIcon="arrow-right"
          insideIconSize={8}
        />
      )
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.businessReport !== nextProps.businessReport) {
      this.setNavigation(false);
    }

    if (
      this.props.country !== nextProps.country ||
      this.props.costcenter !== nextProps.costcenter
    )
      this.props.actions.fetchRestriction(
        nextProps.country,
        nextProps.costcenter
      );
  }

  setNavigation = nextStatus => {
    this.props.setNavigation({
      left: null,
      middle: null,
      right: (
        <NitroButton
          disabled={nextStatus}
          action={this.props.navigation.goNext}
          label="NEXT"
          variant="primary"
          size="extraSmall"
          rightIcon="arrow-right"
          insideIconSize={8}
        />
      )
    });
  };

  render() {
    const {
      actions,
      businessReport,
      businessReports,
      dynamicFilters
    } = this.props;

    const { costcenter, country } = this.state;

    const filters = [
      {
        title: 'Country',
        component: CountryFilter,
        ...country
      },
      {
        title: 'Company Code',
        component: CostcenterFilter,
        ...costcenter
      },
      ...dynamicFilters
    ];

    const onSourceChange = (index, filter) => {
      const lastFilter = filters.length - 1;
      const isDynamicFilter = filter.typeId;
      console.log({ lastFilter, isDynamicFilter });

      switch (index) {
        case 0:
          console.log(filter);
          this.setState({ country: filter });
          actions.setCountry(filter);
          break;
        case 1:
          this.setState({ costcenter: filter });
          actions.setCostcenter(filter);
          break;
        case lastFilter:
          if (!isDynamicFilter) {
            actions.setBusinessReport(filter);
          } else {
            actions.setDynamicFilters(filter);
          }
          break;
        default:
          actions.setDynamicFilters(filter);
          break;
      }
    };

    const businessReportsList = businessReports.map(report => ({
      value: report.id,
      label: report.name
    }));

    if (!this.props.isEditMode) {
      filters.push({
        title: 'Business report',
        component: SingleSelect,
        options: businessReportsList,
        mandatory: true,
        ...businessReport
      });
    }

    console.log(filters);

    return (
      <Container>
        {filters.map((filter, index) => (
          <FilterSection
            filters={filters}
            action={onSourceChange}
            key={index}
            index={index}
          />
        ))}
      </Container>
    );
  }
}

DataSource.propTypes = {
  actions: PropTypes.object,
  action: PropTypes.func,
  businessReport: PropTypes.object,
  businessReports: PropTypes.array,
  costcenter: PropTypes.object,
  country: PropTypes.object,
  setReportFields: PropTypes.object,
  setNavigation: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool
};

export default DataSource;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/DataSource/DataSource.js